import { createSelector } from 'reselect';
import { getConfigData } from 'src/modules/config/selectors/getConfigData';

export const getApiBaseUrl = createSelector([
  getConfigData,
], (config) => config.environment.apiBaseUrl);
